module.exports = __webpack_public_path__ + "img/female-teenager-figure.b7ae70f4.svg";